/**
 * @module generate/guid
 */

/**
 * Generates a valid v4 GUID as per http://www.ietf.org/rfc/rfc4122.txt
 *
 * <p>Important parts: xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx</p>
 * <p>Where M represents the version and the most significant bits of N represent the variant.</p>
 * <p>See http://guid.one/guid and http://guid.one/guid/make for more info.</p>
 *
 * @returns {string} a valid V4 GUID
 */
export function guidV4() {
    // In Internet Explorer crypto is implemented as experimental so it is only available as msCrypto
    const crypto = window.crypto || window.msCrypto;
    const bytes = crypto.getRandomValues(new Uint8Array(16));

    // Add version data to the byte at index 6
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    // Add variant data to the byte at index 8
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    let i = 0;

    // Replace each x with 2 characters per byte from bytes to create a guid string
    return ('xxxx-xx-xx-xx-xxxxxx').replace(/x/g, () => {
        // Left-pad with 0 for single character values
        const value = ('0' + bytes[i].toString(16)).slice(-2);

        i += 1;

        return value;
    });
}
